import { AbstractControl, ValidationErrors } from '@angular/forms';
  
export class WhitespaceValidator {
    static cannotContainSpace(control: AbstractControl) : ValidationErrors | null {
        if(control.value != undefined && (control.value as string).indexOf(' ') >= 0){
            return {cannotContainSpace: true}
        }  
        return null;
    }
}